module.exports = __webpack_public_path__ + "img/astana3.30e56fb9.jpg";